export default __webpack_public_path__ + "static/media/image-restaurant.1951b576.jpg";